module.exports = __webpack_public_path__ + "static/img/13.1c996c2b.png";